import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LogUtils } from "abweb/utils/log/LogUtils";
import { observable } from "mobx";
import { observer } from "mobx-react";
export class PageStateUtils {
  static logDeprecatedWarningMessage(apiName) {
    const message = `The ${apiName} api is deprecated and will be removed from the product. Please 
    see https://abinitio.atlassian.net/wiki/x/AYDIT (PageState User's Guide) for instructions regarding 
    how to migrate to the new page state system.`;
    PageStateUtils.LOG.warn(message);
  }
}

/**
 * Establishes a component as one that can have @pageState members that are reloaded when a page
 * is refreshed or navigated to in browser history.
 */
_defineProperty(PageStateUtils, "LOG", LogUtils.getLogger(__filename));
export function reloadableExternal(target) {
  PageStateUtils.logDeprecatedWarningMessage("reloadableExternal");
  return target;
}

/**
 * Establishes a component as one that can have @pageState members that are reloaded when a page
 * is refreshed or navigated to in browser history.
 */
export function reloadable(target) {
  PageStateUtils.logDeprecatedWarningMessage("reloadable");
  return target;
}
/**
 * Mobx version of reloadable. All pageState variables within the component are made mobx observable
 * and the component is made a mobx observer. Mutation functions are all marked as actions.
 */
export function reloadableMobx(target) {
  observer(target);
  PageStateUtils.logDeprecatedWarningMessage("reloadableMobx");
  return target;
}
export function makeReloadable(target) {
  PageStateUtils.logDeprecatedWarningMessage("makeReloadable");
  return target;
}
export function pageStateSilent(target, key, propertyDescriptor) {
  PageStateUtils.logDeprecatedWarningMessage("pageStateSilent");
}
export function pageState(target, key, propertyDescriptor) {
  observable(target, key);
  PageStateUtils.logDeprecatedWarningMessage("pageState");
}
export function urlState(target, key, propertyDescriptor) {
  PageStateUtils.logDeprecatedWarningMessage("urlState");
}
//# sourceMappingURL=PageStateUtils.js.map
